import { environment } from '../../environments/environment';

// API Base URLs
export const SERVER_API_URL = environment.apiBaseUrl;
export const SERVER_API_IMG = environment.apiImageUrl;

// Auth API URLs
export const AUTH_API_URL = environment.apiAuthUrl;
export const ADMIN_API_URL = environment.apiAdminUrl;
export const ORGANIZATIONS_API_URL = environment.apiOrganizationsUrl;
export const ADDRESS_API_URL = environment.apiAddressUrl;

// API Paths
export const SERVER_API_AUTH = environment.apiAuthPath;
export const SERVER_API_DATA_COLLECTION = environment.apiDataCollectionPath;
export const SERVER_API_THAM_DINH = environment.apiThamDinhPath;
export const SERVER_API_THAM_DINH_BDS = environment.apiThamDinhBdsPath;
export const SERVER_API_QUAN_LY_TIN_DUNG = environment.apiQuanLyTinDungPath;

// Additional API URLs (constructed from environment)
export const API_OCR_URL = environment.apiOcrUrl;
export const API_EVALUATION_URL = environment.apiEvaluationUrl;